(() => {
  class CampaignCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.units = this.querySelector('[data-countdown-units]');
      this.expiredMessage = this.querySelector('[data-countdown-expired]');
      this.endTime = new Date(this.dataset.endDate || '').getTime();

      if (!Number.isFinite(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.update();

      if (this.endTime > Date.now()) {
        this.intervalId = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    update() {
      const remaining = this.endTime - Date.now();

      if (remaining <= 0) {
        this.finish();
        return;
      }

      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor(remaining / 3600000) % 24,
        minutes: Math.floor(remaining / 60000) % 60,
        seconds: Math.floor(remaining / 1000) % 60,
      };

      Object.entries(values).forEach(([name, value]) => {
        const element = this.querySelector(`[data-campaign-${name}]`);
        if (element) element.textContent = String(value).padStart(2, '0');
      });

      this.setAttribute(
        'aria-label',
        `${values.days} days, ${values.hours} hours, ${values.minutes} minutes, ${values.seconds} seconds remaining`,
      );
    }

    finish() {
      this.stop();
      const showMessage = this.dataset.expiredBehavior === 'message'
        && this.expiredMessage
        && this.expiredMessage.textContent.trim();

      if (!showMessage) {
        this.hidden = true;
        return;
      }

      if (this.units) this.units.hidden = true;
      this.expiredMessage.hidden = false;
      this.setAttribute('aria-label', this.expiredMessage.textContent.trim());
    }
  }

  if (!customElements.get('campaign-countdown')) {
    customElements.define('campaign-countdown', CampaignCountdown);
  }
})();
